import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 20,
    itemTotal: 0,
  },
  list: [],
  reports: [],
  selectedBankEibor: {
    bankEibor: {
      _id: undefined,
    },
    files: [],
  },
  bankEiborAdded: false,
  bankEiborUpdated: false,
  bankEiborRemoved: false,
};

const bankEiborsSlice = createSlice({
  name: "bankEibors",
  initialState,
  reducers: {
    getBankEibors(state, action) {
      state.list = action.payload.eibors;
      state.meta = action.payload.meta;
    },
    getBankEiborsById(state, action) {
      state.selectedBankEibor = action.payload;
    },
    addBankEibors(state, action) {
      state.bankEiborAdded = true;
    },
    updateBankEibors(state, action) {
      state.bankEiborUpdated = true;
    },
    removeBankEibors(state, action) {
      state.bankEiborRemoved = true;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const bankEiborsActions = bankEiborsSlice.actions;
export default bankEiborsSlice;
